import React from "react";
import Icon, { IconProps } from "./Icon";

/**
 * Bell icon for in-app notifications.
 */
export const BellIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 8-3 8h18s-3-1-3-8"></path>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
    </Icon>
  );
};

export default BellIcon;
